import React, { useEffect, useRef, useState } from 'react';
import {
	NoRowsAvailable,
	// InputLabel,
	// InputWrapper,
	OptionsWrapper,
	ProcessingMessage,
	RangeReviewWrapper,
	// RangeWrapper,
	RecordWraper,
	Wrapper,
} from './UpdateApVendorDB.styles';
import {
	ApButtonIcon,
	ApButtonMain,
	// ApInput,
	ApLoaderDefault,
	ApLoaderText,
	colors,
} from '@alixpartners/ui-components';
import EditClassificationThreshold from './EditClassificationThreshold/EditClassificationThreshold';
import UpdateClassificationFlag from './ApVendorDBPivot/UpdateClassificationFlag';
import { useClassificationThresholdContext } from 'contexts/APVendorDBContext/ClassificationThresholdProvider';
import {
	getApVendorDBClassifcationUpdatingStatus,
	updateApVendorDBClassificationPreference,
} from 'utils/apiRequests';
import { useToastMessageContext } from 'contexts/ToastMessageContext/ToastMessageProvider';
import { NotificationTypes } from 'components/Toast/constants';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { encryptObjectToString } from '../utils';

// const numbersArray = Array.from({ length: 200 }, (_, index) => index + 1);

const UpdateApVendorDB = () => {
	const [isModal, setIsModal] = useState(false);
	// const [range, setRange] = useState({ start: null, end: null });
	const [flagList, setFlagList] = useState([]);
	const [isUpdatingClassification, setIsUpdatingClassification] = useState(
		false
	);
	const [
		isAnyClassificationFlagUpdating,
		setIsAnyClassificationFlagUpdating,
	] = useState(false);
	const [isChecking, setIsChecking] = useState(true);
	const { isThresholdSaving } = useClassificationThresholdContext();
	const { showToast } = useToastMessageContext();
	const gridRef = useRef();

	useEffect(
		() => {
			// setIsChecking(false);
			const checkIsPreccessing = async () => {
				const response = await getApVendorDBClassifcationUpdatingStatus();
				if (response.succeeded) {
					if (Object.keys(response.data).length > 0) {
						if (response.data.flag) {
							setIsAnyClassificationFlagUpdating(true);
							showToast(
								'Updating classification flag is in progress.',
								NotificationTypes.success
							);
						} else {
							setIsAnyClassificationFlagUpdating(false);
						}
					} else {
					}
					setIsChecking(false);
				} else {
					setIsChecking(false);
				}
			};

			checkIsPreccessing();
		}, // eslint-disable-next-line
		[]
	);

	const onRowSelectionHandler = params => {
		const dataObj = {
			normalizedVendorName: params.data.normalizedVendorName,
			aP_L1Category: params.data.aP_L1Category,
			aP_L2Category: params.data.aP_L2Category,
			aP_L3Category: params.data.aP_L3Category,
			aP_L4Category: params.data.aP_L4Category,
		};
		const encryptedUniqueString = encryptObjectToString(dataObj);

		if (
			flagList.filter(el => el.uniqueString === encryptedUniqueString).length >
			0
		) {
			const filteredList = flagList.filter(
				el => el.uniqueString !== encryptedUniqueString
			);
			setFlagList(filteredList);
		} else {
			const list = [...flagList];
			if (
				flagList.filter(
					el => el.vendorName === params.data.normalizedVendorName
				).length > 0
			) {
				showToast(
					'For same vendor cannot select 2 classifications',
					NotificationTypes.warning
				);
				let nodeToDeselect = gridRef.current.api.getRowNode(params.node.id);
				nodeToDeselect.selectable = false;
				nodeToDeselect.selected = false;
				gridRef.current.api.redrawRows();
			} else {
				list.push({
					vendorName: params.data.normalizedVendorName,
					uniqueString: encryptedUniqueString,
					normalizedVendorName: params.data.normalizedVendorName,
					aP_L1Category: params.data.aP_L1Category,
					aP_L2Category: params.data.aP_L2Category,
					aP_L3Category: params.data.aP_L3Category,
					aP_L4Category: params.data.aP_L4Category,
				});
				setFlagList(list);
			}
		}
	};

	// const handleCheckIndexes = (startIndex, endIndex) => {
	// 	if (startIndex > endIndex) {
	// 		showToast(
	// 			'Start index is greater than end index.',
	// 			NotificationTypes.danger
	// 		);
	// 		return false;
	// 	} else {
	// 		return true;
	// 	}
	// };

	const updateClassificationFlag = (arr1, arr2) => {
		const flagToChange = arr1
			.filter(el => {
				const dataObj = {
					normalizedVendorName: el.normalizedVendorName,
					aP_L1Category: el.aP_L1Category,
					aP_L2Category: el.aP_L2Category,
					aP_L3Category: el.aP_L3Category,
					aP_L4Category: el.aP_L4Category,
				};
				const encryptedString = encryptObjectToString(dataObj);
				return (
					arr2.filter(el => el.uniqueString === encryptedString).length > 0
				);
			})
			.map(el => ({ ...el, classificationFlag: true }));

		const other = arr1.filter(el => {
			const dataObj = {
				normalizedVendorName: el.normalizedVendorName,
				aP_L1Category: el.aP_L1Category,
				aP_L2Category: el.aP_L2Category,
				aP_L3Category: el.aP_L3Category,
				aP_L4Category: el.aP_L4Category,
			};
			const encryptedString = encryptObjectToString(dataObj);
			return !arr2.filter(el => el.uniqueString === encryptedString).length > 0;
		});

		return {
			updateCertificationFlagRequestToOne: flagToChange,
			updateCertificationFlagRequest: other,
		};
	};

	const onReviewHandler = () => {
		let presentGridData = [];

		gridRef.current.api.forEachNode(rowNode => {
			if (rowNode !== undefined || rowNode !== null) {
				let obj = {};
				obj.normalizedVendorName = rowNode.data.normalizedVendorName;
				obj.aP_L1Category = rowNode.data.aP_L1Category;
				obj.aP_L2Category = rowNode.data.aP_L2Category;
				obj.aP_L3Category = rowNode.data.aP_L3Category;
				obj.aP_L4Category = rowNode.data.aP_L4Category;
				obj.classificationFlag = rowNode.data.classificationFlag;
				presentGridData.push(obj);
			}
		});

		if (presentGridData.length > 0) {
			const updatedArrayNew = updateClassificationFlag(
				presentGridData,
				flagList
			);
			setIsUpdatingClassification(true);
			updateApVendorDBClassificationPreference(updatedArrayNew).then(
				response => {
					if (response.succeeded) {
						setIsUpdatingClassification(false);
						showToast(
							'Classification flag updated successfully.',
							NotificationTypes.success
						);
						setFlagList([]);
					} else {
						showToast(
							'Failed to update the classification flag.',
							NotificationTypes.danger
						);
						setIsUpdatingClassification(false);
					}
				}
			);

			// if (
			// 	numbersArray.includes(range.start) &&
			// 	numbersArray.includes(range.end)
			// ) {
			// 	const isAppropriateRange = handleCheckIndexes(range.start, range.end);
			// 	if (isAppropriateRange) {
			// 		showToast('Make API call', NotificationTypes.success);
			// 	} else {
			// 		showToast('Dont Make API call', NotificationTypes.warning);
			// 	}
			// } else {
			// 	showToast('Enter valid range.', NotificationTypes.warning);
			// }
		} else {
			showToast('No rows to review.', NotificationTypes.warning, 3000);
		}
	};

	return (
		<Wrapper>
			{isChecking ? (
				<ApLoaderDefault loaderText={() => <ApLoaderText />} />
			) : (
				<>
					{isAnyClassificationFlagUpdating ? (
						<ProcessingMessage>
							Updating classification flag is in progress. Please wait for the
							current execution to complete.
						</ProcessingMessage>
					) : (
						<>
							<>
								<OptionsWrapper>
									<div>
										<ApButtonIcon
											title={`Settings`}
											iconName="baseline_tune"
											iconProps={{ iconColor: colors.grey8 }}
											onClick={() => setIsModal(true)}
										>
											Settings
										</ApButtonIcon>
									</div>
									<div>
										<RangeReviewWrapper>
											{/* <RangeWrapper>
												<InputLabel>Start: </InputLabel>
												<InputWrapper>
													<ApInput
														className="start_rowindex"
														type="number"
														name="start_index"
														onChange={v => {
															if (isNaN(v) || v === '') {
																setRange(prevState => ({ ...prevState, start: null }));
															} else {
																setRange(prevState => ({
																	...prevState,
																	start: parseInt(v),
																}));
															}
														}}
														maxLength={3}
														value={range.start === null ? '' : range.start}
														shouldStopPropagation
													/>
												</InputWrapper>
												<InputLabel>End:</InputLabel>
												<InputWrapper>
													<ApInput
														className="end_rowindex"
														type="number"
														name="end_index"
														onChange={v => {
															if (isNaN(v) || v === '') {
																setRange(prevState => ({ ...prevState, end: null }));
															} else {
																setRange(prevState => ({
																	...prevState,
																	end: parseInt(v),
																}));
															}
														}}
														value={range.end === null ? '' : range.end}
														maxLength={3}
														shouldStopPropagation
													/>
												</InputWrapper>
										</RangeWrapper> */}
											<div>
												<ApButtonMain onClick={onReviewHandler}>
													Mark As Reviewed
												</ApButtonMain>
											</div>
										</RangeReviewWrapper>
									</div>
								</OptionsWrapper>

								<RecordWraper>
									{!isThresholdSaving && !isUpdatingClassification ? (
										<UpdateClassificationFlag
											gridRef={gridRef}
											onRowSelectionHandler={onRowSelectionHandler}
											flagList={flagList}
										/>
									) : (
										<ApLoaderDefault loaderText={() => <ApLoaderText />} />
									)}
								</RecordWraper>
							</>
						</>
					)}
				</>
			)}
			{isModal && (
				<>
					<EditClassificationThreshold setIsModal={setIsModal} />
				</>
			)}
			<ApSignalrConsumer
				message="UpdateClassificationChanged"
				onMessage={() => {
					showToast(
						'Classification flag updated successfully.',
						NotificationTypes.success
					);
					setIsAnyClassificationFlagUpdating(false);
				}}
			/>
		</Wrapper>
	);
};

export default UpdateApVendorDB;
